import { useQuery } from 'react-query';

import Api from '../../api/api';

export const getPostById = async (postId: string) => {
  const [response, bodyOrError] = await Api.get(`posts/${postId}`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useGetPostById = (postId: string) =>
  useQuery(['getPostById', postId], () => getPostById(postId), {
    enabled: postId !== 'new' || !!postId,
  });
